<template>
  <Radar :data="radar_chart_data" :darkmode="enable_darkmode" />
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useCampaignStore } from "@/stores/campaign.js";
import { useOnboardingStore } from "@/stores/onboarding.js";
import Radar from "@/components/charts/Radar.vue";

const route = useRoute();

const campaignStore =
  route.name === "campaign" ? useCampaignStore() : useOnboardingStore();

const { currentCampaign } = storeToRefs(campaignStore);

const props = defineProps({
  modules: {
    type: Array,
    required: true,
  },
  candidate: {
    type: Object,
  },
  campaign_scores: {
    type: Array,
  },
  enable_darkmode: {
    type: Boolean,
    default: true,
  },
});

const candidate_scores = computed(() => {
  if (!props.candidate.results) return [];

  const sortedResults = Object.entries(props.candidate.results)
    .filter(([key]) =>
      props.modules.some((elt) => {
        if (currentCampaign.value.version === 1) {
          return key === elt.id;
        }

        return key === `${elt.id_v2 ?? elt.id}_score`;
      })
    )
    .sort(([id_a], [id_b]) => {
      const indexA = props.modules.findIndex(
        (elt) =>
          elt.id_v2 === id_a.replace("_score", "") ||
          elt.id === id_a.replace("_score", "")
      );

      const indexB = props.modules.findIndex(
        (elt) =>
          elt.id_v2 === id_b.replace("_score", "") ||
          elt.id === id_b.replace("_score", "")
      );

      return indexA - indexB;
    });

  return sortedResults.map(([key, result]) => {
    return result.score;
  });
});

const radar_chart_data = computed(() => {
  return {
    labels: props.modules.map((elt) => elt.name),
    datasets: [
      {
        label: `${props.candidate?.candidate?.first_name} ${props.candidate?.candidate?.last_name}`,
        backgroundColor: "rgba(242,203,54,0.2)",
        borderColor: "rgba(242,203,54,1)",
        pointBackgroundColor: "rgba(242,203,54,1)",
        pointBorderColor: "rgba(242,203,54,1)",
        pointHoverBackgroundColor: "rgba(242,203,54,1)",
        pointHoverBorderColor: "rgba(242,203,54,1)",
        data: candidate_scores.value,
      },
      {
        label: "Talents de la campagne",
        backgroundColor: props.enable_darkmode
          ? "rgba(30,48,217,0.2)"
          : "rgba(29,29,29,0.2)",
        borderColor: props.enable_darkmode
          ? "rgba(30,48,217,1)"
          : "rgba(29,29,29,1)",
        pointBackgroundColor: props.enable_darkmode
          ? "rgba(30,48,217,1)"
          : "rgba(29,29,29,1)",
        pointBorderColor: props.enable_darkmode
          ? "rgba(30,48,217,1)"
          : "rgba(29,29,29,1)",
        pointHoverBackgroundColor: props.enable_darkmode
          ? "rgba(30,48,217,1)"
          : "rgba(29,29,29,1)",
        pointHoverBorderColor: props.enable_darkmode
          ? "rgba(30,48,217,1)"
          : "rgba(29,29,29,1)",
        data: props.campaign_scores,
      },
    ],
  };
});
</script>
